import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BuoyXWebApp } from "@buoy-x/web-shell";
import "@buoy-x/web-shell/styles.css";
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BuoyXWebApp admin />
  </StrictMode>,
);
